exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__option:hover .text-muted[data-v-2f204f42]{color:var(--darken-primary-bg-contrast-text-color)!important}", ""]);

// exports
